import {
  browserLanguage,
  javaEnabled,
  screenWidth,
  screenHeight,
  windowWidth,
  windowHeight,
  screenColorDepth
} from 'lib/utils/browser';

import {
  timezoneName,
  timezoneOffset
} from 'lib/utils/timezone';

export const getBrowserInfo = () => {
  return {
    browserLanguage,
    javaEnabled,
    screenWidth,
    screenHeight,
    windowWidth,
    windowHeight,
    colorDepth: screenColorDepth,
    timezone: getTimezone(),
  };
};

export const getTimezone = () => {
  return {
    name: timezoneName,
    offset: timezoneOffset,
  };
};
